import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'groups';
const BASE_PATH = `${API_ROOT}/groups`;
const PATHS = {
    CREATE: (groupId) => `${BASE_PATH}/${groupId}/members`,
    DELETE: (groupId, memberId) => `${BASE_PATH}/${groupId}/members/${memberId}`,
    GET: (groupId, memberId) => `${BASE_PATH}/${groupId}/members/${memberId}`,
    LIST: (groupId) => `${BASE_PATH}/${groupId}/members`,
    RESEND_EMAIL: (groupId, memberId) => `${BASE_PATH}/${groupId}/members/${memberId}/resendEmail`,
    UPDATE: (groupId, memberId) => `${BASE_PATH}/${groupId}/members/${memberId}`,
};
async function create(csrfToken, groupId, email, role) {
    return (await (await SecureAxios()).post(PATHS.CREATE(groupId), { email, role }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function delete_(csrfToken, groupId, memberId) {
    return (await (await SecureAxios()).delete(PATHS.DELETE(groupId, memberId), { headers: { 'X-CSRF-Token': csrfToken } }))
        .data;
}
async function get(groupId, memberId) {
    return (await (await SecureAxios()).get(PATHS.GET(groupId, memberId))).data;
}
function getKey(groupId, memberId) {
    return [CacheKey, 'get', groupId, memberId];
}
async function list(groupId, props) {
    const params = new URLSearchParams();
    if (props.limit)
        params.append('limit', props.limit.toString());
    if (props.offset)
        params.append('offset', props.offset.toString());
    if (props.orderBy)
        params.append('orderBy', props.orderBy);
    if (props.order)
        params.append('order', props.order);
    if (props.query)
        params.append('q', props.query);
    if (props.preload)
        params.append('preload', props.preload.join(','));
    return (await (await SecureAxios()).get(`${PATHS.LIST(groupId)}?${params.toString()}`)).data;
}
function listKey(groupId, props) {
    return [CacheKey, 'list', groupId, props];
}
async function resendEmail(csrfToken, groupId, memberId) {
    return (await (await SecureAxios()).post(PATHS.RESEND_EMAIL(groupId, memberId), {}, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function update(csrfToken, groupId, memberId, props) {
    return (await (await SecureAxios()).put(PATHS.UPDATE(groupId, memberId), { ...props }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
export default { create, delete_, get, getKey, list, listKey, resendEmail, update };
